import React from 'react';

export const SolidLoader = () => {
    return <div className='loader'></div>;
};
